import * as React from 'react';
import { Label } from '@cian/ui-kit';
import { IconTrust16 } from '@cian/ui-kit/icons';

import * as styles from './styles.css';

export interface IReliableLabelProps extends React.HTMLAttributes<HTMLDivElement> {
  light?: boolean;
  onOpen?(): void;
  onClick?(event: React.MouseEvent<HTMLElement>): void;
}

export const ReliableLabel = React.forwardRef((props: IReliableLabelProps, ref: React.Ref<HTMLDivElement>) => {
  return (
    <div className={styles['label']} {...props} onClick={props.onClick} ref={ref}>
      <Label
        background={props.light ? 'rgba(4, 104, 255, 0.1)' : '#0468ff'}
        color={props.light ? 'primary_100' : 'white_100'}
        icon={<IconTrust16 color={props.light ? 'primary_100' : 'white_100'} />}
        onMouseEnter={props.onOpen}
      >
        Надёжный корпус
      </Label>
    </div>
  );
});

ReliableLabel.displayName = 'ReliableLabel';
